// extracted by mini-css-extract-plugin
export default {"container":"IndexParameter-module__container__gQ8UQsE","label":"IndexParameter-module__label__bzFUVrd"};